module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	]
};